export default __webpack_public_path__ + "locales/si/Files.json?hash=72419ed9e300a4d479bca36c69eddd62";